// extracted by mini-css-extract-plugin
export default {"startnow":"StartNow_startnow__QwU-r","startnow__title":"StartNow_startnow__title__C6yJY","startnow__inner":"StartNow_startnow__inner__8+OJb"};